import { expVal } from '@atlassian/jira-feature-experiments';

const ShowTranslatedNameForCustomFieldRelayProvider = {
	get(): boolean {
		return expVal('show-translated-name-for-custom-field', 'isEnabled', false);
	},
};

export default ShowTranslatedNameForCustomFieldRelayProvider;
